'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var oidcClient = require('oidc-client');
require('regenerator-runtime/runtime');
var reactRouterDom = require('react-router-dom');

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

var IDENTITY_CONFIG = function IDENTITY_CONFIG(authConfig) {
  var obj = {};

  if (authConfig.signingKeys) {
    obj.signingKeys = authConfig.signingKeys;
  }

  return _objectSpread2(_objectSpread2({}, obj), {}, {
    authority: authConfig.authority,
    //(string): The URL of the OIDC provider.
    client_id: authConfig.client_id,
    //(string): Your client application's identifier as registered with the OIDC provider.
    redirect_uri: authConfig.redirect_uri,
    //The URI of your client application to receive a response from the OIDC provider.
    login: authConfig.authority + "/login",
    automaticSilentRenew: true,
    //(boolean, default: false): Flag to indicate if there should be an automatic attempt to renew the access token prior to its expiration.
    loadUserInfo: authConfig.loadUserInfo,
    //(boolean, default: true): Flag to control if additional identity data is loaded from the user info endpoint in order to populate the user's profile.
    silent_redirect_uri: authConfig.silent_redirect_uri,
    //(string): The URL for the page containing the code handling the silent renew.
    post_logout_redirect_uri: authConfig.post_logout_redirect_uri,
    // (string): The OIDC post-logout redirect URI.
    issuer: authConfig.authority,
    responseType: "id_token token",
    //(string, default: 'id_token'): The type of response desired from the OIDC provider.
    scope: "openid",
    //(string, default: 'openid'): The scope being requested from the OIDC provider.
    includeIdTokenInSilentRenew: true,
    accessTokenExpiringNotificationTime: 30,
    monitorSession: false
  });
};
var METADATA_OIDC = function METADATA_OIDC(authConfig) {
  return {
    issuer: authConfig.issuer,
    jwks_uri: authConfig.wso2Url + "/oauth2/jwks",
    authorization_endpoint: authConfig.wso2Url + "/oauth2/authorize",
    token_endpoint: authConfig.wso2Url + "/oauth2/token",
    userinfo_endpoint: authConfig.wso2Url + "/oauth2/userinfo",
    end_session_endpoint: authConfig.wso2Url + "/oidc/logout",
    revocation_endpoint: authConfig.wso2Url + "/oauth2/revocation",
    introspection_endpoint: authConfig.wso2Url + "/oauth2/introspect",
    check_session_iframe: authConfig.wso2Url + "/oidc/checksession?client_id=" + authConfig.client_id + "&redirect_uri=" + authConfig.silent_redirect_uri + "&prompt=none",
    userStore: new oidcClient.WebStorageStateStore({
      store: window.sessionStorage
    })
  };
};

var AuthService = /*#__PURE__*/function () {
  function AuthService(authConfig) {
    var _this = this;

    _classCallCheck(this, AuthService);

    _defineProperty(this, "UserManager", void 0);

    _defineProperty(this, "authConfig", void 0);

    _defineProperty(this, "signinRedirectCallback", function () {
      var url = window.location.href.replace("#", "?");

      var params = _this.getUrlVars(url);

      _this.UserManager.signinRedirectCallback(params).then(function () {
        window.history.replaceState({}, window.document.title, window.location.origin);
        window.location = "/";
      });
    });

    _defineProperty(this, "getUser", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var user;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.UserManager.getUser();

            case 2:
              user = _context.sent;

              if (user) {
                _context.next = 7;
                break;
              }

              _context.next = 6;
              return _this.UserManager.signinRedirectCallback(null);

            case 6:
              return _context.abrupt("return", _context.sent);

            case 7:
              return _context.abrupt("return", user);

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));

    _defineProperty(this, "parseJwt", function (token) {
      var base64Url = token.split(".")[1];
      var base64 = base64Url.replace("-", "+").replace("_", "/");
      return JSON.parse(window.atob(base64));
    });

    _defineProperty(this, "signinRedirect", function () {
      sessionStorage.setItem("redirectUri", window.location.pathname);

      _this.UserManager.signinRedirect({
        state: window.location.pathname
      });
    });

    _defineProperty(this, "navigateToScreen", function () {
      var redirectUri = !!sessionStorage.getItem("redirectUri") ? sessionStorage.getItem("redirectUri") : "/en/";
      var language = "/" + redirectUri.split("/")[1];
      window.location.replace(language);
    });

    _defineProperty(this, "isAuthenticated", function () {
      var access_token = sessionStorage.getItem("access_token");
      var id_token = sessionStorage.getItem("id_token");

      if (id_token && access_token) {
        var data = _this.parseJwt(id_token);

        var isValid = new Date(data.exp * 1000) > Date.now();
        return isValid;
      }

      return false;
    });

    _defineProperty(this, "signinSilent", function () {
      _this.UserManager.signinSilent();
    });

    _defineProperty(this, "signinSilentCallback", function () {
      _this.UserManager.signinSilentCallback();
    });

    _defineProperty(this, "createSigninRequest", function () {
      return _this.UserManager.createSigninRequest();
    });

    _defineProperty(this, "logout", function () {
      _this.UserManager.signoutRedirect({
        id_token_hint: sessionStorage.getItem("id_token")
      }).then(function (res) {
        _this.UserManager.removeUser();

        sessionStorage.clear();
      });
    });

    _defineProperty(this, "signoutRedirectCallback", function () {
      _this.UserManager.signoutRedirectCallback().then(function () {
        _this.UserManager.removeUser();

        sessionStorage.clear();
        window.location.replace(process.env.REACT_APP_PUBLIC_URL);
      });

      _this.UserManager.clearStaleState();
    });

    _defineProperty(this, "getUrlVars", function (url) {
      var vars = {};
      var parts = url.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (m, key, value) {
        vars[key] = value;
      });
      return vars;
    });

    this.authConfig = authConfig;
    this.UserManager = new oidcClient.UserManager(_objectSpread2(_objectSpread2({}, IDENTITY_CONFIG(authConfig)), {}, {
      // userStore: new WebStorageStateStore({ store: window.sessionStorage }),
      metadata: _objectSpread2({}, METADATA_OIDC(authConfig)),
      response_type: "id_token token"
    })); // Logger
    // Log.logger = console;
    // Log.level = Log.DEBUG;

    this.UserManager.events.addUserLoaded(function (user) {
      sessionStorage.setItem("access_token", user.access_token);
      sessionStorage.setItem("id_token", user.id_token);
    });
    this.UserManager.events.addUserUnloaded(function (user) {});
    this.UserManager.events.addSilentRenewError(function (e) {// console.error("silent renew error", e.message);
    });
    this.UserManager.events.addAccessTokenExpiring(function (e) {
      console.debug("token expiring...");

      _this.signinSilent();
    });
    this.UserManager.events.addUserSignedIn(function (user) {
      console.log("addUserSignedIn", user);
    });
    this.UserManager.events.addUserSignedOut(function (user) {
      console.log("addUserSignedOut", user);
    });
    this.UserManager.events.addUserSessionChanged(function (user) {
      console.log("addUserSessionChanged", user);
    });
    this.UserManager.events.addAccessTokenExpired(function () {
      console.log("addAccessTokenExpired", user);

      _this.signoutRedirectCallback(); // UIkit.notification.closeAll("token");

    });
  }

  _createClass(AuthService, [{
    key: "getProfileInfo",
    value: function () {
      var _getProfileInfo = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _this$authConfig$prof, url, microserviceId, _yield$this$getUser, profile, id_token, access_token, paramsGroupsRoles;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this$authConfig$prof = this.authConfig.profileManager, url = _this$authConfig$prof.url, microserviceId = _this$authConfig$prof.microserviceId;
                _context2.next = 3;
                return this.getUser();

              case 3:
                _yield$this$getUser = _context2.sent;
                profile = _yield$this$getUser.profile;
                id_token = _yield$this$getUser.id_token;
                access_token = _yield$this$getUser.access_token;
                paramsGroupsRoles = profile.groups.map(function (x) {
                  return "wso2roles=" + x;
                }).join("&");
                return _context2.abrupt("return", fetch(url + "/microservices/" + microserviceId + "/profiles?" + paramsGroupsRoles, {
                  headers: {
                    Authorization: "Bearer " + access_token,
                    "X-Auth-Token": id_token
                  }
                }));

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getProfileInfo() {
        return _getProfileInfo.apply(this, arguments);
      }

      return getProfileInfo;
    }()
  }]);

  return AuthService;
}();

var AuthContext = /*#__PURE__*/React__default.createContext({
  signinRedirectCallback: function signinRedirectCallback(authService) {
    authService.signinRedirectCallback();
  },
  logout: function logout(authService) {
    authService.logout();
  },
  signoutRedirectCallback: function signoutRedirectCallback(authService) {
    authService.signoutRedirectCallback();
  },
  isAuthenticated: function isAuthenticated(authService) {
    return authService.isAuthenticated();
  },
  signinRedirect: function signinRedirect(authService) {
    authService.signinRedirect();
  }
});
var AuthConsumer = AuthContext.Consumer;
var AuthProvider = /*#__PURE__*/function (_Component) {
  _inherits(AuthProvider, _Component);

  var _super = _createSuper(AuthProvider);

  function AuthProvider(props) {
    var _this;

    _classCallCheck(this, AuthProvider);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "authService", void 0);

    var authConfig = props.authConfig;
    _this.authService = new AuthService(authConfig);
    return _this;
  }

  _createClass(AuthProvider, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React__default.createElement(AuthContext.Provider, {
        value: this.authService
      }, this.props.children);
    }
  }]);

  return AuthProvider;
}(React.Component);

var PrivateRoute = function PrivateRoute(_ref) {
  var component = _ref.component,
      rest = _objectWithoutProperties(_ref, ["component"]);

  var renderFn = function renderFn(Component) {
    return function (props) {
      return /*#__PURE__*/React__default.createElement(AuthConsumer, null, function (_ref2) {
        var isAuthenticated = _ref2.isAuthenticated,
            signinRedirect = _ref2.signinRedirect;

        if (!!Component && isAuthenticated()) {
          return /*#__PURE__*/React__default.createElement(Component, props);
        } else {
          signinRedirect();
          return /*#__PURE__*/React__default.createElement("span", null, "loading");
        }
      });
    };
  };

  return /*#__PURE__*/React__default.createElement(reactRouterDom.Route, _extends({}, rest, {
    render: renderFn(component)
  }));
};

var LjsaAuthModule = /*#__PURE__*/function (_Component) {
  _inherits(LjsaAuthModule, _Component);

  var _super = _createSuper(LjsaAuthModule);

  function LjsaAuthModule() {
    _classCallCheck(this, LjsaAuthModule);

    return _super.apply(this, arguments);
  }

  _createClass(LjsaAuthModule, [{
    key: "render",
    value: // static propTypes = {
    //   authConfig: PropTypes.object
    // }
    function render() {
      var _this$props = this.props,
          authConfig = _this$props.authConfig,
          children = _this$props.children;
      return /*#__PURE__*/React__default.createElement(AuthProvider, {
        authConfig: authConfig
      }, children);
    }
  }]);

  return LjsaAuthModule;
}(React.Component);

exports.AuthConsumer = AuthConsumer;
exports.AuthContext = AuthContext;
exports.AuthProvider = AuthProvider;
exports.AuthService = AuthService;
exports.PrivateRoute = PrivateRoute;
exports.default = LjsaAuthModule;
